import { Form } from 'antd';
import styled from 'styled-components';
import { theme } from '../../../styles/theme';

export const StyledForm = styled(Form)`
  p {
    font-size: 1.125rem;
    font-weight: inherit;
    margin-bottom: .75rem;
  }
`;

export const FormItemsWrapper = styled.div`
  padding: 1.5rem;

  > p {
    font-weight: bold;
    color: ${theme.color.darkGray};
    padding: .5rem 0;
  }
`;

export const BloodlineDiseasesWrapper = styled.div`
  .number-container {
    display: flex;
    justify-content: space-between;
    padding-bottom: .5rem;
  }
`;
